import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import { SUBMITTALS_DETAIL_TOUR_ID } from './detail';
import { SUBMITTALS_LIST_TOUR_ID } from './list';
import {
  attachmentsStep,
  closeStep,
  combinedTableStep,
  filtersStep,
  headerActionsStep,
  metadataStep,
  newSubmittalStep,
  revisionsStep,
  workflowStep,
} from './steps';

export const SUBMITTALS_COMBINED_TOUR_ID = 'submittals.combined';

registerTour({
  id: SUBMITTALS_COMBINED_TOUR_ID,
  name: 'Submittals',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.SUBMITTALS.id,
  alsoMarks: [SUBMITTALS_LIST_TOUR_ID, SUBMITTALS_DETAIL_TOUR_ID],
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Submittals',
      body:
        'Track shop drawings, product data, samples, and any other ' +
        'submittal that needs review and approval — through every revision.',
    },
    newSubmittalStep,
    filtersStep,
    combinedTableStep,
    headerActionsStep,
    metadataStep,
    workflowStep,
    closeStep,
    attachmentsStep,
    revisionsStep,
  ],
});
